export default __webpack_public_path__ + "static/anastasiaFrame-c0cd5a0eb0405331249dda7b8693c03d.png";